function calculateAge(dateString) {
  // Parse the date string into a Date object
  const parts = dateString.split(/[\/,: ]/); // Split by / or : or space

  const birthDate = new Date(parts[2], parts[0] - 1, parts[1]); // Year, Month (zero-based), Day

  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in years
  const age = currentDate.getFullYear() - birthDate.getFullYear();

  // Adjust the age based on the month and day
  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() < birthDate.getDate())
  ) {
    // Subtract 1 year if the birthdate hasn't occurred yet this year
    return age - 1;
  }

  return age;
}

export default calculateAge;

export const convertLocaleStringToDateInputValue = (localeDateString) => {
  const date = new Date(localeDateString);
  const year = date.getFullYear();
  let month = date.getMonth() + 1; // JavaScript months are 0-based.
  let day = date.getDate();

  // Pad month and day with leading zeros if necessary.
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;

  return `${year}-${month}-${day}`;
};

export const convertLocaleStringToDateTimeInputValue = (localeDateString) => {
  const date = new Date(localeDateString);
  const year = date.getFullYear();
  let month = date.getMonth() + 1; // JavaScript months are 0-based.
  let day = date.getDate();
  let hour = date.getHours();
  let minutes = date.getMinutes();

  // Pad month and day with leading zeros if necessary.
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  if (hour < 10) hour = "0" + hour;
  if (minutes < 10) minutes = "0" + minutes;

  return `${year}-${month}-${day}T${hour}:${minutes}`;
};

export const getDOB = (dateString, birthday) => {
  const parts = dateString.split(/[/, ]/); // Split by slash, comma, and space
  const month = parseInt(parts[0], 10) - 1; // Months are zero-indexed in JS Date
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  // Create the Date object
  const date = new Date(year, month, day);

  // Format the date to a readable string
  const options = birthday
    ? { month: "long", day: "numeric" }
    : { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export function timeAgo(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const seconds = Math.floor((now - date) / 1000);

  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  for (const interval of intervals) {
    const count = Math.floor(seconds / interval.seconds);
    if (count >= 1) {
      if (interval.label === "day" && count > 2) {
        return date.toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      }
      return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
    }
  }

  return "just now";
}